import { render } from "./assetComparePopup.vue?vue&type=template&id=af89cd3c"
import script from "./assetComparePopup.vue?vue&type=script&lang=js"
export * from "./assetComparePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__